import React, { memo } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import bemit from 'Functions/bemit';
export default memo(function BookingMainContent({
  ...props
}) {
  const step = BookingFormStore.useState(s => s.step);
  const modifiers = ['booking-left'];
  if (props['white-label-booking']) {
    modifiers.push('white-label-booking');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: bemit('o-page-part', modifiers) + (step === 1 ? ' u-flex-grow-1' : '')
  }, props.children);
});
